import { useTheme } from '@mui/material/styles';
import { CommonStyledLink } from 'common/components/links/styles/common-link.style';
import { OrganizationalTagPagesTypeEnum } from 'features/static-data';
import { useRouter } from 'common/hooks';
import AppRoutesEnum from 'common/routes/AppRoutes.enum';
import { Typography } from 'common/components/material';

const StaticDataLink: React.FC<{
  type: OrganizationalTagPagesTypeEnum;
  id?: string;
  name?: string;
  isVisible?: boolean;
}> = ({ type, id, name, isVisible }) => {
  const { palette } = useTheme();
  const { getOrgRoute } = useRouter();

  if (!id || !name) {
    return null;
  }

  const pageRoute = getOrgRoute(AppRoutesEnum.STATIC_DATA_SUMMARY, {
    staticDataId: id,
    staticDataType: type,
  });

  return (
    <>
      <CommonStyledLink href={pageRoute} color="inherit" fontWeight={500} fontSize="inherit">
        {name}
      </CommonStyledLink>
      {!isVisible && (
        <Typography variant="caption2" color={palette.Text.Caption} fontStyle="italic">
          {' '}
          (inactive)
        </Typography>
      )}
    </>
  );
};

export default StaticDataLink;
